var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWorkflows(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#5E5E66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9773_57957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: 123000,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.37 5.64C16.97 5.23 16.43 5 15.86 5C15.56 5 15.27 5.06 15 5.19V3.88C15 2.84 14.16 2 13.12 2H3.88C2.84 2 2 2.84 2 3.88V16.12C2 17.16 2.84 18 3.88 18H13.12C14.16 18 15 17.16 15 16.12V11.16L17.37 8.73C17.77 8.32 18 7.77 18 7.19C18 6.61 17.77 6.05 17.37 5.64ZM13.5 16.12C13.5 16.33 13.33 16.5 13.12 16.5H3.88C3.67 16.5 3.5 16.33 3.5 16.12V3.88C3.5 3.67 3.67 3.5 3.88 3.5H13.12C13.33 3.5 13.5 3.67 13.5 3.88V6.51L8.55 11.58C8.43 11.7 8.35 11.85 8.33 12.02L8.01 14.33C7.97 14.57 8.05 14.82 8.23 15C8.4 15.17 8.64 15.25 8.88 15.22L11.14 14.89C11.3 14.87 11.45 14.79 11.57 14.67L13.5 12.69V16.12ZM16.29 7.62L15 8.94L13.5 10.47L10.66 13.37L9.68 13.51L9.82 12.5L13.5 8.73L15 7.2L15.44 6.75C15.55 6.64 15.7 6.57 15.86 6.57C16.02 6.57 16.17 6.64 16.29 6.75C16.4 6.87 16.46 7.02 16.46 7.19C16.46 7.35 16.4 7.5 16.29 7.62Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9773_57957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflows);
export default __webpack_public_path__ + "static/media/workflows.cf542146.svg";
export { ForwardRef as ReactComponent };